export default function AboutSection() {
  return (
    <section id="hakkimizda" className="py-20 md:py-28 bg-[#fdf8f4]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Top label */}
        <div className="flex items-center gap-3 mb-14">
          <span className="w-10 h-px bg-[#e8734a]"></span>
          <span className="text-[#e8734a] text-sm font-semibold tracking-widest uppercase">Hakkımızda</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          {/* Left: Images stacked */}
          <div className="relative">
            {/* Main image */}
            <div className="relative rounded-3xl overflow-hidden w-full h-[420px] md:h-[520px]">
              <img
                src="https://public.readdy.ai/ai/img_res/21e481032c185816f1eb4b2f0dc07de1.jpg"
                alt="Balıkçı Zafer İç Mekan"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              <div className="absolute bottom-5 left-5 right-5">
                <p className="text-white font-semibold text-sm">"Her tabak, denizin tazeliğini sofraya taşır."</p>
                <p className="text-white/60 text-xs mt-1">— Zafer Ailesi</p>
              </div>
            </div>

            {/* Small overlay image */}
            <div className="absolute -bottom-8 -right-4 md:-right-10 w-40 h-40 md:w-52 md:h-52 rounded-2xl overflow-hidden border-4 border-white">
              <img
                src="https://readdy.ai/api/search-image?query=close%20up%20fresh%20whole%20fish%20on%20crushed%20ice%20at%20fish%20market%20counter%2C%20colorful%20variety%20of%20mediterranean%20sea%20fish%2C%20glistening%20scales%2C%20vibrant%20colors%2C%20professional%20food%20photography&width=300&height=300&seq=about_small&orientation=squarish"
                alt="Taze Balıklar"
                className="w-full h-full object-cover object-center"
              />
            </div>

            {/* Badge */}
            <div className="absolute top-5 left-5 flex flex-col gap-2">
              {["🐟 Günlük Taze Av", "👨‍👩‍👧 Aile İşletmesi"].map((b) => (
                <span key={b} className="bg-white/95 text-[#1a3a4a] text-xs font-bold px-3 py-1.5 rounded-full">
                  {b}
                </span>
              ))}
            </div>
          </div>

          {/* Right: Content */}
          <div className="lg:pl-4 pb-8 lg:pb-0">
            <h2 className="text-4xl md:text-5xl font-bold text-[#1a3a4a] leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              Zafer Ailesi'nin<br />
              <span className="text-[#e8734a]">Balık Tutkusu</span>
            </h2>

            <p className="text-gray-600 text-base leading-relaxed mb-5">
              Balıkçı Zafer, Ege'nin bereketli sularında büyüyen Zafer ailesi tarafından İzmir Aliağa'da kurulmuş bir aile restoranıdır. Sabahın ilk ışıklarıyla denize açılan teknelerden, akşam sofralarınıza uzanan taze bir yolculuk sunuyoruz.
            </p>

            <p className="text-gray-600 text-base leading-relaxed mb-10">
              Geleneksel Ege balıkçılık kültürünü ve ev yemeği sıcaklığını bir arada yaşatıyoruz. Kalamar tavadan levrek ızgaraya, midye dolmadan deniz mahsulleri salatalarına kadar her tabak özenle hazırlanıyor.
            </p>

            {/* Feature list */}
            <div className="space-y-4">
              {[
                { icon: "ri-sun-line", title: "Her Sabah Taze", desc: "Günlük avlanan balıklar, aynı gün servis edilir" },
                { icon: "ri-heart-3-line", title: "Aile Tarifi", desc: "Nesilden nesile geçen geleneksel Ege tarifleri" },
                { icon: "ri-leaf-line", title: "Doğal & Katkısız", desc: "Hiçbir yapay katkı maddesi kullanmıyoruz" },
              ].map((item) => (
                <div key={item.title} className="flex items-center gap-4 p-4 bg-white rounded-2xl border border-orange-50">
                  <div className="w-11 h-11 flex items-center justify-center bg-[#e8734a]/10 rounded-xl flex-shrink-0">
                    <i className={`${item.icon} text-[#e8734a] text-lg`}></i>
                  </div>
                  <div>
                    <div className="text-[#1a3a4a] font-bold text-sm">{item.title}</div>
                    <div className="text-gray-500 text-xs mt-0.5">{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
